import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { AppInsightsServiceDirective } from './shared/services/app-insights.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler implements ErrorHandler {
  constructor(public appInsights: AppInsightsServiceDirective) {}

  handleError(error: Error | HttpErrorResponse) {
    if (error instanceof HttpErrorResponse) {
      // Server error
      if (error.status !== 404) {
        this.appInsights.logError(error);
      }
    } else {
      // Client Error
      this.appInsights.logError(error);
    }
  }
}
